import { useEffect, useRef } from 'react';
import styled from 'styled-components';

import { Divider as BaseDivider } from '@treezor/design-system';

import { useCreateUserContext } from '@/features/user/contexts/CreateUserContext';
import { CreateUserContentContainer } from '@/features/user/components/CreateUser/layout/CreateUserContentContainer';
import { useStepNavigationConfig } from '@/features/user/hooks/createUser/useStepNavigationConfig';
import { StepIndication } from '@/features/user/components/CreateUser/StepNavigation/StepIndication';
import { UserTypeSelection } from '@/features/user/components/CreateUser/UserTypeSelection';

const Divider = styled(BaseDivider)`
  margin: ${({ theme }) => theme.spacing[8]} 0;
`;

export const StepNavigaton = () => {
  const { userType, currentStep } = useCreateUserContext();
  const { stepTitle, steps } = useStepNavigationConfig({ userType });
  const containerRef = useRef(null);

  useEffect(() => {
    // Scroll to the top of the page whenever the step changes
    if (currentStep !== undefined && containerRef?.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [currentStep]);

  if (!userType) return <UserTypeSelection />;

  const currentView = steps[currentStep];

  return (
    <div className="grid grid-cols-[296px_1fr] gap-5">
      <CreateUserContentContainer>
        <StepIndication currentStep={currentStep} steps={steps} userType={userType} />
      </CreateUserContentContainer>
      <CreateUserContentContainer isFill>
        <div className="overflow-auto p-7" ref={containerRef}>
          <div className="flex flex-col gap-2 text-secondary">
            <h3 className="typo-h3-bold">{stepTitle}</h3>
            <h4 className="typo-h4-regular">{currentView.name}</h4>

            {currentView.description && (
              <p className="pt-4 typo-body-regular-paragraphLarge">{currentView.description}</p>
            )}
          </div>
          <Divider />

          <div>{currentView.content}</div>
        </div>
      </CreateUserContentContainer>
    </div>
  );
};
